<script>
  import { afterUpdate, onMount } from "svelte";
  import {
    baseUrl,
    getUrlVars,
    inIframe,
    handleMargins,
    handleDarkModeSettings,
    useDarkMode,
    isForcedColorMode,
  } from "../../scripts/loadExternalData";
  import { initTracking } from "../../scripts/tracker";

  export const events = initTracking();

  export const state = {
    title: "",
    introduction: "",
    source: "",
    subtext: "",
    sections: [],
    imageWidth: "",
    columnAmount: 1,
    textColor: false,
    darkMode: false,
    darkModeSettings: "no_settings",
  };

  let myRenderDarkMode = false;
  let myRenderForcedColorMode = false;

  export let graphicTitle = "";
  export let hasSentInView = false;

  onMount(async () => {
    await fetch(`${baseUrl}/fields/${getUrlVars().id}`)
      .then((data) => data.json())
      .then(({ fields, title }) => {
        graphicTitle = title;

        for (let name in state) {
          if (!fields.find(({ key }) => key === name)) continue;

          state[name] = fields.find(({ key }) => key === name).value;
        }
      });

    handleDarkModeSettings(
      state.darkMode,
      state.darkMode,
      state.darkModeSettings
    );

    myRenderDarkMode = useDarkMode();
    myRenderForcedColorMode = isForcedColorMode();

    if (myRenderDarkMode) {
      document.getElementsByTagName("body")[0].classList.add("body__dark-mode");
    } else {
      document
        .getElementsByTagName("body")[0]
        .classList.add("body__light-mode");
    }

    window.addEventListener("resize", () => postRatio());

    if (!inIframe()) {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      document.getElementsByTagName("body")[0].style.margin = "0";
    } else {
      if (window.innerWidth <= 620) {
        document.getElementsByTagName("body")[0].style.margin = "0";
      }
    }
  });

  const postRatio = () => {
    const containerElement = document.getElementsByTagName("body")[0];
    window.parent.postMessage(
      {
        ratio: containerElement.offsetHeight / window.innerWidth,
        location: window.location.href,
      },
      "*"
    );
  };

  const setupInviewEvent = () => {
    window.addEventListener("message", (ev) => {
      if (hasSentInView) return;

      if (typeof ev.data === "string" && ev.data.includes("INSIDE_VIEW")) {
        events.enterIntoView(
          "Visible",
          "multigrafik",
          state.title || graphicTitle || ""
        );
        hasSentInView = true;
      } else if (ev.data.isScrolledIntoView) {
        events.enterIntoView(
          "Visible",
          "multigrafik",
          state.title || graphicTitle || ""
        );
        hasSentInView = true;
      }
    });
  };

  const setupLiveData = () => {
    window.addEventListener("message", (ev) => {
      if (!ev.data.key || ev.data.value === undefined) return;

      const { key, value } = ev.data;

      if (key === "sections") {
        setTimeout(() => postRatio(), 50);

        state[key] = value.map((section) => {
          return {
            Titel: section.titel,
            Ingress: section.ingress,
            image: section.image,
          };
        });
      } else {
        if (state[key] === "" && value.length > 0) {
          setTimeout(() => postRatio(), 50);
        }

        state[key] = value;
      }
    });
  };

  afterUpdate(() => {
    window.addEventListener("resize", () => postRatio());
    if (state.images || state.titleTexts) {
      setupLiveData();
      setupInviewEvent();
      postRatio();
    }
  });
</script>

<main
  class={`main__content-wrapper ${
    handleMargins() ? "main__padded-width" : "main__normal-width"
  } ${myRenderDarkMode ? "main__dark-mode" : "main__light-mode"} ${
    myRenderForcedColorMode ? "main__padded-top-bottom" : ""
  } ${state.borderToBorder ? "content-wrapper-border-to-border" : ""} ${
    handleMargins() && !getUrlVars().fullWidth ? "main__full-width" : ""
  }`}
  style={`color: ${state.textColor ? state.textColor : "unset"}`}
>
  {#if state.title}
    <div class="standard-title">
      {@html state.title}
    </div>
  {/if}
  {#if state.introduction}
    <div class="standard-ingress">
      {@html state.introduction}
    </div>
  {/if}
  {#if state.sections.length}
    <div
      class="grid-wrapper"
      style={`grid-template-columns: repeat(${state.columnAmount}, 1fr);`}
    >
      {#each state.sections as section, i}
        <div>
          {#if section.Titel}
            {#if i === 0 && !state.title}
              <div
                style="margin-top: 0px;"
                class="standard-title standard-subheading-title"
              >
                {@html section.Titel}
              </div>
            {:else}
              <div class="standard-title standard-subheading-title">
                {@html section.Titel}
              </div>
            {/if}
          {/if}
          {#if section.Ingress}
            <div class="standard-ingress standard-subheading-ingress">
              {@html section.Ingress}
            </div>
          {/if}
          {#if section.image}
            <img
              on:load={() => postRatio()}
              class="standard-image"
              style={state.imageWidth
                ? `max-width: ${state.imageWidth}px;`
                : "max-width: 520px;"}
              src={section.image}
              alt={section.Titel}
            />
          {/if}
        </div>
      {/each}
    </div>
  {/if}
  {#if state.source}
    <div class="standard-source">
      {@html state.source}
    </div>
  {/if}
</main>

<style>
  .grid-wrapper {
    display: grid;
    grid-gap: 8px;
  }
  .main__content-wrapper {
    max-width: 680px;
    margin: 0px;
    position: relative;
  }

  .standard-image {
    width: 100%;
    image-rendering: optimizeQuality;
    padding-bottom: 16px;
  }

  .standard-source {
    margin-top: 2px;
  }

  @media screen and (max-width: 640px) {
    .main__full-width {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  @media screen and (min-width: 640px) {
    .main__full-width {
      margin: 0 auto;
    }
  }
</style>
